import { create } from 'zustand';
import { persist, devtools } from 'zustand/middleware';
import { Customer } from '@/types/models';

interface CustomerStore {
  customers: Customer[];
  addCustomer: (customer: Customer) => void;
  updateCustomer: (customer: Customer) => void;
  deleteCustomer: (id: string) => void;
  getCustomers: () => Customer[];
}

export const useCustomerStore = create<CustomerStore>()(
  devtools(
    persist(
      (set, get) => ({
        customers: [
          {
              id: 'CUS-001',
              name: 'Alice Smith',
              phone: '081234567890',
              email: 'alice@example.com',
              address: '123 Main St, Springfield',
              totalOrders: 15,
              totalSpent: 1250000,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
            },
            {
              id: 'CUS-002',
              name: 'Bob Johnson',
              phone: '081298765432',
              email: 'bob@example.com',
              totalOrders: 8,
              totalSpent: 450000,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
            },
            {
              id: 'CUS-003',
              name: 'Charlie Brown',
              phone: '081345678901',
              address: '456 Oak Ave, Metropolis',
              totalOrders: 3,
              totalSpent: 150000,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
            },
            {
              id: 'CUS-004',
              name: 'Diana Prince',
              phone: '081112223333',
              email: 'diana@themyscira.com',
              totalOrders: 50,
              totalSpent: 5000000,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
            },
            {
              id: 'CUS-005',
              name: 'Evan Wright',
              phone: '081998877665',
              totalOrders: 1,
              totalSpent: 45000,
              createdAt: new Date().toISOString(),
              updatedAt: new Date().toISOString(),
            },
        ],
        addCustomer: (customer) =>
          set(
            (state) => ({ customers: [customer, ...state.customers] }),
            false,
            'customer/addCustomer'
          ),
        updateCustomer: (updatedCustomer) =>
          set(
            (state) => ({
              customers: state.customers.map((c) =>
                c.id === updatedCustomer.id ? updatedCustomer : c
              ),
            }),
            false,
            'customer/updateCustomer'
          ),
        deleteCustomer: (id) =>
          set(
            (state) => ({
              customers: state.customers.filter((c) => c.id !== id),
            }),
            false,
            'customer/deleteCustomer'
          ),
        getCustomers: () => get().customers,
      }),
      {
        name: 'customer-store',
      }
    ),
    { name: 'CustomerStore' }
  )
);
